import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PubSub, CONNECTION_STATE_CHANGE, ConnectionState} from '@aws-amplify/pubsub';

@Injectable({
  providedIn: 'root'
})
export class IotService {

  pubsub? : PubSub
  
  constructor() { }

  getClient(): PubSub { 

    if (!this.pubsub) {
      this.pubsub = new PubSub({
        region: environment.awsRegion,
        endpoint: environment.awsMqttHost 
      });
    }

    return this.pubsub ;
  }
}
